module.exports = __webpack_public_path__ + "static/media/payjak-logotype-l.3921ad5b.svg";